/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getCategories } from "@eisinc/App/Services/CategoryService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";

export const xPopulateApiParameter: any = (props: any) => {
    const { onSuccess, ...parameter } = props.parameter;
    props.apiParameter = { ...parameter, expand: "featuredproducts", numberoffeaturedproducts: 2 };
};

export const XngRequestDataFromApi: any = async (props: any) => {
    props.apiResult = await getCategories(props.apiParameter);
};

replaceInChain(chain, PopulateApiParameter, xPopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
